import { Location, Route } from 'vue-router';
import { Store } from 'vuex';

import { CONTAINER, TYPES } from '../config';

import { GuardClass, GuardResolveFunction } from '../models';

import { ROUTER_CONSTS } from '../router/router.consts';

import { AuthTokenService } from '../services';

import { AUTH_CONSTS } from '../store/auth/auth.consts';

export class LoginGuard extends GuardClass {

  public static async execute(to: Route, from: Route, next: GuardResolveFunction): Promise<void> {
    let redirectLocation: Location;
    const store = CONTAINER.get<Store<any>>(TYPES.Store);
    let token: string = store.getters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.token}`];
    if (!token) {
      token = await store.dispatch(`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.actions.loadStateFromStorage}`);
    }
    const keepLoggedIn: boolean = store.getters[`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.getters.keepLoggedIn}`];
    const authTokenService: AuthTokenService = CONTAINER.get<AuthTokenService>(TYPES.AuthTokenService);
    if (!!token && keepLoggedIn && authTokenService.isNearToExpire(token, ((1000 * 60) * 10))) {
      try {
        token = await store.dispatch(`${AUTH_CONSTS.moduleName}/${AUTH_CONSTS.actions.refresh}`);
      } catch (error) {}
    }
    const tokenIsExpired = (!!token ? authTokenService.isExpired(token) : true);
    if (tokenIsExpired) {
      if (to.name !== ROUTER_CONSTS.routes.login) {
        redirectLocation = {
          name: ROUTER_CONSTS.routes.logout
        };
        if (to.path !== '/') {
          redirectLocation.query = {
            [ROUTER_CONSTS.query.redirect]: to.fullPath
          };
        }
      }
    } else {
      const redirectPath = to.query[ROUTER_CONSTS.query.redirect];
      if (!!redirectPath) {
        redirectLocation = {
          path: (redirectPath as string)
        };
      } else if (to.name === ROUTER_CONSTS.routes.login) {
        redirectLocation = {
          ...to,
          name: ROUTER_CONSTS.routes.home
        };
      }
    }
    if (!!redirectLocation) {
      redirectLocation.replace = true;
    }
    next(redirectLocation);
  }

}
